var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h9A1.5 1.5 0 0 1 12 1.5v6A1.5 1.5 0 0 1 10.5 9h-9A1.5 1.5 0 0 1 0 7.5zM1.5.75a.75.75 0 0 0-.75.75v.163L6 4.813l5.25-3.15V1.5a.75.75 0 0 0-.75-.75zm9.75 1.787L7.719 4.656l3.531 2.173zm-.025 5.157-4.23-2.603L6 5.687l-.994-.596-4.23 2.603a.75.75 0 0 0 .724.556h9a.75.75 0 0 0 .725-.556M.75 6.829l3.531-2.173L.75 2.537z"
  })));
};
export default SvgEmail;